
import { mapGetters } from "vuex";
import {
	AD_LAYOUT_STUBS,
	AD_PLACEMENTS,
	INTERLINK_SPECIAL_CASE,
	PAGES,
} from "@consts";

export default {
	name: "WordsByLength",
	data() {
		return {
			AD_LAYOUT_STUBS,
			AD_PLACEMENTS,
		};
	},
	computed: {
		...mapGetters("navigation", [
			"isWordListDistributorPage",
			"isWordlistIndexPage",
			"isWordleLandingPage",
			"isQuordleLandingPage",
			"isHomePage",
		]),
		interlinkCase() {
			switch (this.$route.name) {
				case PAGES.WORDS_BY_LENGTH_LANDING_4:
					return INTERLINK_SPECIAL_CASE.LENGTH_4;
				case PAGES.WORDS_BY_LENGTH_LANDING_5:
					return INTERLINK_SPECIAL_CASE.LENGTH_5;
				case PAGES.WORDS_BY_LENGTH_LANDING_5_STARTS:
					return INTERLINK_SPECIAL_CASE.LENGTH_5_NO_STARTS;
				case PAGES.WORDS_BY_LENGTH_LANDING_5_ENDS:
					return INTERLINK_SPECIAL_CASE.LENGTH_5_NO_ENDS;
				case PAGES.WORDS_BY_LENGTH_LANDING_5_HAVING:
					return INTERLINK_SPECIAL_CASE.LENGTH_5_NO_WITH;
				case PAGES.WORDS_BY_LENGTH_LANDING_6:
					return INTERLINK_SPECIAL_CASE.LENGTH_6;
				case PAGES.WORDS_BY_LENGTH_LANDING_7:
					return INTERLINK_SPECIAL_CASE.LENGTH_7;
				case PAGES.WORDS_BY_LENGTH_LANDING_8:
					return INTERLINK_SPECIAL_CASE.LENGTH_8;
				default:
					return INTERLINK_SPECIAL_CASE.FALLBACK;
			}
		},
		isSingleFieldWordLengthLandingPage() {
			return [
				PAGES.WORDS_BY_LENGTH_LANDING_5_STARTS,
				PAGES.WORDS_BY_LENGTH_LANDING_5_ENDS,
				PAGES.WORDS_BY_LENGTH_LANDING_5_HAVING,
			].includes(this.$route.name);
		},
		headingText() {
			switch (this.$route.name) {
				case PAGES.WORDS_BY_LENGTH_LANDING_4:
					return {
						main: "4 Letter Word Finder & Unscrambler",
						subtitle:
							"Search, filter, and solve for 4-letter words",
					};

				case PAGES.WORDS_BY_LENGTH_LANDING_5:
					return {
						main: "5 Letter Word Finder & Unscrambler",
						subtitle:
							"Search, filter, and solve for 5-letter words",
					};
				case PAGES.WORDS_BY_LENGTH_LANDING_5_STARTS:
					return {
						main: "5 Letter Words Starting With",
						subtitle: "",
					};
				case PAGES.WORDS_BY_LENGTH_LANDING_5_ENDS:
					return {
						main: "5 Letter Words Ending In",
						subtitle: "",
					};
				case PAGES.WORDS_BY_LENGTH_LANDING_5_HAVING:
					return {
						main: "5 Letter Words With These Letters",
						subtitle: "",
					};
				case PAGES.WORDS_BY_LENGTH_LANDING_6:
					return {
						main: "6 Letter Word Finder & Unscrambler",
						subtitle:
							"Search, filter, and solve for 6-letter words",
					};
				case PAGES.WORDS_BY_LENGTH_LANDING_7:
					return {
						main: "7 Letter Word Finder & Unscrambler",
						subtitle:
							"Search, filter, and solve for 7-letter words",
					};
				case PAGES.WORDS_BY_LENGTH_LANDING_8:
					return {
						main: "8 Letter Word Finder & Unscrambler",
						subtitle:
							"Search, filter, and solve for 8-letter words",
					};
				default:
					return {
						main: "",
						subtitle: "",
					};
			}
		},
	},
	methods: {},
};
